import { Flex, Text, Box } from '@chakra-ui/core'
import React from 'react'
import { DropdownMenu } from 'components/ui'
import { ChevronDown } from 'lucide-react'
import { Controller, useFormContext } from 'react-hook-form'
import { useFormStepContext } from '../../FormStepContext'
import useLocaleText from 'components/useLocaleText'
import { ErrorMessage } from 'components/ui/Input/ErrorMessage'

export const AllowedOverdueDays = () => {
  const { control, watch, errors } = useFormContext()
  const { maxAllowedOverdueDays } = useFormStepContext()

  const allowedOverdueDays = watch('allowed_overdue_days')

  const t_allowedOverdue = useLocaleText('allowed_overdue')
  const t_allowedOverdue_error = useLocaleText('t_empty_field')

  const t_choose = useLocaleText('choose') || 'Choose'

  const ALL_OPTIONS = [0, 1, 2, 3, 4, 5, 6, 7, 14, 30, 60]
  const visibleOptions = ALL_OPTIONS.filter((n) => n < maxAllowedOverdueDays)

  return (
    <Box>
      <Flex alignItems="center" style={{ columnGap: '10px' }} mb="5px">
        <Text>{t_allowedOverdue}</Text>
        <Controller
          name="allowed_overdue_days"
          control={control}
          rules={{
            validate: (value) => {
              if (value === null || value === undefined || value === '') {
                return t_allowedOverdue_error
              }
              return true
            },
          }}
          as={({ onChange }) => (
            <DropdownMenu
              usePortal
              options={visibleOptions.map((num) => ({ id: String(num), value: num, label: <>{num}</> }))}
              selectedId={String(allowedOverdueDays)}
              onSelect={({ value }) => onChange(value)}
              triggerVariant="secondary"
              triggerButtonProps={{
                type: 'button',
                height: '36px',
                minWidth: '80px',
                px: '12px',
                justifyContent: 'space-between',
                'aria-label': t_allowedOverdue,
                'aria-invalid': !!errors.allowed_overdue_days,
                borderColor: errors.allowed_overdue_days ? '#EA9999' : '#E2E8F0',
              }}
              triggerContent={
                <>
                  {allowedOverdueDays === null || allowedOverdueDays === undefined || allowedOverdueDays === ''
                    ? t_choose
                    : allowedOverdueDays}
                  <ChevronDown size={14} />
                </>
              }
            />
          )}
        />
      </Flex>
      {errors?.allowed_overdue_days && (
        <Box px="10px" pt="5px">
          <ErrorMessage errorMessage={t_allowedOverdue_error} />
        </Box>
      )}
    </Box>
  )
}
